"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Image_1 = require("./Image");
exports.default = Image_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Image/index.js
// module id = 290
// module chunks = 8